import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from 'app/app.module';
import posthog from "posthog-js";
import {environment} from './environments/environment';


// Initialize PostHog only if keys are available
if (environment.POSTHOG_KEY && environment.POSTHOG_HOST) {
    posthog.init(environment.POSTHOG_KEY, {
        api_host: environment.POSTHOG_HOST,
        person_profiles: 'identified_only',
        defaults: '2025-05-24',
        // Disable screen recordings for privacy
        disable_session_recording: true,
        // Additional privacy settings
        autocapture: false,
        capture_pageview: true,
        capture_pageleave: false
    });
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .then(() => {
        // Initialize PostHog anonymous profile after the app is bootstrapped
        if (environment.POSTHOG_KEY && environment.POSTHOG_HOST) {
            // The PostHog services will be automatically initialized
            // and anonymous profiles will be created as needed
        }
    })
    .catch(err => console.error(err));